module.exports = __webpack_public_path__ + "static/media/logo-bricoprive--squared.93470f0d.png";